import { create } from "zustand";

export const useStore = create((set) => ({

  setRefillStatus: (carefill_id, status) =>
    set((state) => ({
      refill_list: state.refill_list.map((item) =>
        item.carefill_id === carefill_id
          ? { ...item, carefill_status: parseInt(status) }
          : item
      ),
    })),

  refills: [],
  setRefills: (refills) => set({ refills }),

  refill_list: [],
  setRefillList: (refill_list) => set({ refill_list }),

  pdfData: [],
  setPdfData: (pdfData) => set({ pdfData }),

  medList: [],
  setMedList: (medList) => set({ medList }),

  searchState: 0,
  setSearch: (searchState) => set({ searchState }),

  searchTrigger: false,
  setTrigger: (searchTrigger) => set({ searchTrigger }),

  result: [],
  set_result: (result) => set({ result }),

  currentPage: 1,
  setCurrentPage: (currentPage) => set({ currentPage }),

  pageSize: 20,
  setPageSize: (pageSize) => set({ pageSize }),

  totalPages: 1,
  setTotalPages: (totalPages) => set({ totalPages }),
}))
